import React, { useEffect, useState } from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite, Paragraph } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';
import api from '../../services/api';
import { useParams } from 'react-router-dom';
import { urlWebsite } from '../../config';
import IframePlayer from '../../components/IframePlayer';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

interface IProps {
  hash?: string;
}

const EventsPages: React.FC<IProps> = ({ hash = '' }) => {

  const { projectHash, url = hash } = useParams<Record<string, any>>();
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageContent, setPageContent] = useState<Record<string, any>>({});

  const load = async () => {
    if (url) {
      setLoading(true);

      const response = await api.get(`/show-page/${projectHash}/${url}`);

      if (response) {
        setPageContent(response.data);
        setReady(true);
      }
      else {
        setReady(true);
      }
      setLoading(false);
    }
  }

  useEffect(() => {

    load();

  }, [url, projectHash])

  return (
    <>

      <Container style={{ flexDirection: pageContent?.orientation === 'column' ? 'column' : 'row', background: pageContent?.theme_data?.background ? pageContent?.theme_data?.background : pageContent?.image ? `url("${urlWebsite}/${pageContent?.image}")` : '#fff' }} >
        <div className='content'>
          <h2 className='titleElement' style={{ borderBottom: pageContent?.theme_data?.line_color ? `2px solid ${pageContent?.theme_data?.title_color}` : '2px solid #ddd', color: pageContent?.theme_data?.title_color ? pageContent?.theme_data?.title_color : '#333' }}>{pageContent?.title}</h2>
          <Paragraph color={pageContent?.theme_data?.text_color ? pageContent?.theme_data?.text_color : '#333'} dangerouslySetInnerHTML={{ __html: pageContent?.description || '' }} />

          {pageContent?.files && pageContent?.files.map((item) => {
            return <a href={`${urlWebsite}/${item.url}`} target="_blank"><button className='defaultButton'>{item.title}</button></a>
          })}

          {pageContent?.buttons?.length > 0 ? <div style={{ margin: '20px auto' }}>
            {pageContent?.buttons && pageContent?.buttons.map((itemButton) => {
              return <a href={`${itemButton.link}`} ><button className={itemButton.class_name || 'greenButton2 shadow'}>{itemButton.title}</button></a>
            })}
          </div> : <></>}
        </div>

        {pageContent?.images && pageContent?.images?.length > 0 && pageContent?.images?.map(image => {

          return <img src={`${urlWebsite}/${image?.url}`} />

        })}

        {pageContent?.video ? <div className='imageHolder'><IframePlayer id={pageContent?.video} /></div> : <></>}


      </Container>
    </>
  );
};
export default EventsPages;
